<template>
<div class="chapter">
<div class="inner_page">
<p class="h2"><a id="page_vii"></a>Contents</p>
<p class="tocb"><a href="#/html/9780226260501_06_pre#pre">Preface</a></p>
<p class="toc"><a href="#/html/9780226260501_07_ch1#ch1">Chapter 1: Saving All Sentient Beings</a></p>
<p class="toc"><span href="#/html/9780226260501_08_ch2#ch2" title="Link target outside of Sample">Chapter 2: The Mob</span></p>
<p class="toc"><span href="#/html/9780226260501_09_ch3#ch3" title="Link target outside of Sample">Chapter 3: La Zona</span></p>
<p class="toc"><span href="#/html/9780226260501_10_ch4#ch4" title="Link target outside of Sample">Chapter 4: Hambre</span></p>
<p class="toc"><span href="#/html/9780226260501_11_ch5#ch5" title="Link target outside of Sample">Chapter 5: A Bullet Don’t Have Nobody’s Name on It</span></p>
<p class="toc"><span href="#/html/9780226260501_12_ch6#ch6" title="Link target outside of Sample">Chapter 6: War</span></p>
<p class="toc"><span href="#/html/9780226260501_13_ch7#ch7" title="Link target outside of Sample">Chapter 7: Coexistence</span></p>
<p class="toc"><span href="#/html/9780226260501_13a_bm#mat" title="Link target outside of Sample">Flip Bbook: The Mating Ritual</span></p>
<p class="toct"><span href="#/html/9780226260501_14_bib#bib" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/html/9780226260501_15_ind#ind" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780226260501_05_toc.vue?0056cd58